import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class CertificatesContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>


            <div className="portfolio-area circle-icon bottom-less">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center">
                        
                            <div className="row masonary">
                                <div id="portfolio-grid" className="portfolio-items col-3">
                                    <div className="portfolio-items">
                                    {this.props.certificates.map((item, index) => (
                                        <div className="pf-item construction">
                                            <div className="item">
                                                <div className="effect-up"> <img src={item.image} alt={item.title}  />
                                                <div className="overlay">
                                                    <div className="link"> <Link href={item.image}  className="item popup-gallery"><i className="fa fa-search"></i></Link> </div>
                                                </div>
                                                </div>
                                                <div className="info">
                                                <h3>{item.title} </h3>
                                                    <ul>
                                                    
                                                    <li>{item.subtitle}</li>
                                                    </ul>
                                                <br />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           
  
     
        <br />
        <br />
        </div>
       

    );
 
    }
}

export default CertificatesContent;